import { apiSlice } from "@/app/api/apiSlice";

export const logsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getVesselOnOffBoardLogs: builder.query({
			query: ({ vesselId }) => `/api/vessels/${vesselId}/onboard-log-vessel`,
			providesTags: ["OnOffBoardLogs"],
		}),
		getUserOnOffBoardLogs: builder.query({
			query: ({ vesselId, userId }) => `/api/vessels/${vesselId}/users/${userId}/onboard-log-user`,
			providesTags: ["OnOffBoardLogs"],
		}),
	}),
	overrideExisting: true,
});

export const { useGetVesselOnOffBoardLogsQuery, useGetUserOnOffBoardLogsQuery } = logsApiSlice;
